
import CardPropertyBooleanVue from '../../components/Card/CardPropertyBoolean.vue'

export default {
  extends: CardPropertyBooleanVue,
  watch: {
    'object.workExperienceStartDate': {
      handler: function () {
        if (!this.object.workExperienceStartDate) {
          this.object[this.tabProp.key] = false
        }
        this.setEditable()
      }
    }
  },
  created: function () {
    this.tabProp.editableInitial = this.tabProp.editable
    this.setEditable()
  },
  methods: {
    setEditable: function () {
      this.tabProp.editable = this.tabProp.editableInitial && !!this.object.workExperienceStartDate
    }
  }
}
